
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-luxury-950 text-white py-8">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center justify-center">
          {/* Logo with 150% size increase */}
          <Link to="/" className="mb-6" onClick={() => window.scrollTo(0, 0)}>
            <img 
              src="/lovable-uploads/071231bc-7ebb-4c11-b2d8-241e00e8cb83.png" 
              alt="LovaBuild Logo" 
              className="h-[4.5rem]" // Increased from h-12 (3rem) to 4.5rem (150% increase)
            />
          </Link>
          
          {/* Copyright Section */}
          <div className="text-center">
            <p className="text-luxury-400 mb-2">
              Copyright {currentYear} | <span className="text-gold">LovaBuild</span>
            </p>
            <div className="flex justify-center space-x-4">
              <Link to="/privacy" className="text-luxury-400 hover:text-gold transition-colors" onClick={() => window.scrollTo(0, 0)}>
                Privacy Policy
              </Link>
              <span className="text-luxury-400">|</span>
              <Link to="/terms" className="text-luxury-400 hover:text-gold transition-colors" onClick={() => window.scrollTo(0, 0)}>
                Terms of Use
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
